// extracted by mini-css-extract-plugin
export default {"container":"UPuEm","headerContainer":"vK2Y8","header":"zcgcs","icon":"UpzX7","notifications":"ro0h8"};